exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-editor[data-v-46680d27] {\n  position: relative;\n  padding: 16px 8px 0;\n  margin-top: 16px;\n}\n.button-editor:hover.hover-bg[data-v-46680d27] {\n  border-radius: 4px;\n}\n.hover-buttons[data-v-46680d27] {\n  display: none;\n  position: absolute;\n  right: 8px;\n  top: 12px;\n}\n.edit-row:hover .hover-buttons[data-v-46680d27] {\n  display: block;\n}\n.action-icon[data-v-46680d27] {\n  cursor: pointer;\n}\n[data-v-46680d27] .hover-buttons .material-icons {\n  font-size: 18px;\n  color: rgba(0, 0, 0, 0.6);\n}\n", ""]);

// exports
